import { graphqlApolloClient } from "../graphql-apollo-client"
import {
  UPDATE_MEANS_OF_VERIFICATION,
  CREATE_MEANS_OF_VERIFICATION,
  DELETE_MANY_DOCUMENTS_BY_URL
} from "./graphql"

export const meansOfVerificationService = () => {
  /**
   * @param {Array<MeansOfVerification>} updatedMeansOfVerificationPerMonth
   * @param {string} activityOrIndicatorId,
   * @param {"INDICATOR" | "ACTIVITY"} relationType
   * @return {Promise<Array<MeansOfVerification>>}
   */
  const updateMeansOfVerificationPerMonth = async ({
    updatedMeansOfVerificationPerMonth,
    activityOrIndicatorId,
    relationType
  }) => {
    const newMeansOfVerificationPerMonth = []
    const meansOfVerificationPerMonthToUpdate = []

    updatedMeansOfVerificationPerMonth.forEach(mov => {
      if (mov.id)
        meansOfVerificationPerMonthToUpdate.push(mov)
      else
        newMeansOfVerificationPerMonth.push(mov)
    })

    const updateResult = meansOfVerificationPerMonthToUpdate.length
      ? await graphqlApolloClient.mutate({
        mutation: UPDATE_MEANS_OF_VERIFICATION,
        variables: {
          relationType,
          id: activityOrIndicatorId,
          data: meansOfVerificationPerMonthToUpdate
        }
      })
      : null

    const createResult = newMeansOfVerificationPerMonth.length
      ? await graphqlApolloClient.mutate({
        mutation: CREATE_MEANS_OF_VERIFICATION,
        variables: {
          relationType,
          id: activityOrIndicatorId,
          data: newMeansOfVerificationPerMonth
        }
      })
      : null

    return updateResult || createResult
  }

  const deleteLegacyMeansOfVerificationByURL =
    async legacyMeansOfVerificationToDelete => {
      await graphqlApolloClient.mutate({
        mutation: DELETE_MANY_DOCUMENTS_BY_URL,
        variables: {
          documentsToDelete: legacyMeansOfVerificationToDelete
        }
      })
    }

  return {
    updateMeansOfVerificationPerMonth,
    deleteLegacyMeansOfVerificationByURL
  }
}

/**
 * @typedef MeansOfVerification
 * @property {string} id
 * @property {number} month
 * @property {number} year
 * @property {number} monthProgress
 * @property {boolean} isRevisionBlocked
 * @property {array.<Document>} verificationDocumentsPerMonth
 */

/**
 * @typedef Document
 * @property {string} id
 * @property {string} url
 * @property {string} name
 * @property {string} type
 */
